<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="formulario.marca"
          label="Marca"
          outlined
          clearable
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="formulario.modelo"
          label="Modelos"
          outlined
          clearable
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="formulario.tipo"
          label="Tipo"
          outlined
          clearable
        />
      </v-col>

    <v-col cols="12" sm="6" md="6"  v-if="$auth.can(['administrador','operador']) && $auth.user().institucion.tipo===1">
      <v-btn color="secondary" @click="crear">Agregar</v-btn>
    </v-col>
    </v-row>

  </div>
</template>

<script>
import InputTramite from '@/components/Input/InputTramite'
import ChipCuenta from '@/admin/components/ChipCuenta'


import { VTextField } from 'vuetify/lib/components'

export default {
  components: {
    ChipCuenta,
    InputTramite,
    VTextField
  },
  data() {
    return {
      formulario:{},
      modelos: [],

    }
  },
  computed: { },
  mounted() {  },
  methods: {
    crear(modelo)
    {
      this.$axios
        .post(`bum/permisos-provisionales/modelos-vehiculos/crear/`, this.formulario)
        .then((response) => {
          const mensaje = `${response.data.modelo.marca} ${response.data.modelo.modelo} ${response.data.modelo.tipo} agregado correctamente.`
          alert(mensaje)
          this.$router.push('/permisos-provisionales/modelos-vehiculos')
        })

    }

  }
}
</script>
